import React from "react";
import { Box, Skeleton, alpha, useTheme } from "@mui/material";

interface LoadingStateProps {
  variant?: "list" | "form" | "card";
  count?: number;
  height?: number;
  spacing?: number;
  withIcon?: boolean;
  withChip?: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  variant = "list",
  count = 3,
  height = 48,
  spacing = 2,
  withIcon = true,
  withChip = false,
}) => {
  const theme = useTheme();

  const renderListItem = () => (
    <Box
      sx={{
        p: 1.5,
        mb: spacing === 0 ? 0 : 1,
        borderRadius: 1,
        border: 1,
        borderColor: "divider",
        bgcolor: (theme) => alpha(theme.palette.background.default, 0.6),
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {withIcon && <Skeleton variant="circular" width={24} height={24} />}
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="60%" height={24} />
          {variant === "card" && (
            <Skeleton variant="text" width="40%" height={20} />
          )}
        </Box>
        {withChip && <Skeleton variant="rounded" width={80} height={24} />}
      </Box>
    </Box>
  );

  const renderFormItem = () => (
    <Box sx={{ mb: spacing }}>
      <Skeleton variant="text" width={120} height={24} sx={{ mb: 1 }} />
      <Skeleton
        variant="rectangular"
        height={height}
        sx={{ borderRadius: 1 }}
      />
    </Box>
  );

  return (
    <Box>
      {Array.from({ length: count }).map((_, index) => (
        <React.Fragment key={index}>
          {variant === "form" ? renderFormItem() : renderListItem()}
        </React.Fragment>
      ))}
    </Box>
  );
};
